import { APIClient } from '../utils/APIClient';
import { API_URL } from '../settings/local_settings';

// API wrapper for "Data Explorer Views" (saved views) and Portal Report Assignments.
// Endpoints documentados en Dashbo-Backend/monitor_api/urls.py (search "data-explorer-views").
export const PortalReportsApi = {
    listViews(agencyClientId) {
        const url = `${API_URL}data-explorer-views/?agency_client_id=${encodeURIComponent(agencyClientId)}`;
        return new APIClient(url).call('GET');
    },

    // Card #2420: vistas de TODOS los clientes de la agencia (para abrirlas o replicarlas
    // en el cliente actual). Cada item trae `agency_client_name` para agrupar/rotular.
    listAllViews() {
        return new APIClient(`${API_URL}data-explorer-views/?scope=all_clients`).call('GET');
    },

    createView(payload) {
        // payload: { name, description?, agency_client_id, config, assign_to_portal?, target_client_ids?[] }
        return new APIClient(`${API_URL}data-explorer-views/`).call('POST', payload);
    },

    getView(viewId) {
        return new APIClient(`${API_URL}data-explorer-views/${viewId}/`).call('GET');
    },

    updateView(viewId, payload) {
        // payload: { name?, description?, config? }
        return new APIClient(`${API_URL}data-explorer-views/${viewId}/`).call('PATCH', payload);
    },

    deleteView(viewId) {
        return new APIClient(`${API_URL}data-explorer-views/${viewId}/`).call('DELETE');
    },

    duplicateView(viewId, payload) {
        // payload: { target_client_ids[], assign_to_portal? }
        return new APIClient(`${API_URL}data-explorer-views/${viewId}/duplicate/`).call('POST', payload);
    },

    assignToPortal(viewId, order) {
        const body = { view_id: viewId };
        if (order !== undefined && order !== null) body.order = order;
        return new APIClient(`${API_URL}portal-report-assignments/`).call('POST', body);
    },

    unassignFromPortal(assignmentId) {
        return new APIClient(`${API_URL}portal-report-assignments/${assignmentId}/`).call('DELETE');
    },

    reorderAssignments(agencyClientId, orderedIds) {
        return new APIClient(`${API_URL}portal-report-assignments/reorder/`)
            .call('PATCH', { agency_client_id: agencyClientId, ordered_ids: orderedIds });
    },

    // Portal del cliente — auth tipo Cliente con permiso reports. `clientId` = cliente
    // ACTIVO (multi-cliente): scopea el alcance y evita que el cache por URL de APIClient
    // cruce datos entre clientes al switchear.
    listMyReports(clientId = null) {
        const suffix = clientId ? `?client_id=${encodeURIComponent(clientId)}` : '';
        return new APIClient(`${API_URL}portal/me/reports/${suffix}`).call('GET');
    },

    queryMyReport(viewId, dateRangeOverride = null, clientId = null) {
        const body = {};
        if (dateRangeOverride) body.date_range_override = dateRangeOverride;
        const suffix = clientId ? `?client_id=${encodeURIComponent(clientId)}` : '';
        return new APIClient(`${API_URL}portal/me/reports/${viewId}/query/${suffix}`).call('POST', body);
    },

    // Preview (agency user previewing como cliente).
    listPreviewReports(clientId) {
        return new APIClient(`${API_URL}portal/preview/${encodeURIComponent(clientId)}/reports/`).call('GET');
    },

    queryPreviewReport(clientId, viewId, dateRangeOverride = null) {
        const body = {};
        if (dateRangeOverride) body.date_range_override = dateRangeOverride;
        return new APIClient(`${API_URL}portal/preview/${encodeURIComponent(clientId)}/reports/${viewId}/query/`).call('POST', body);
    },
};
